import { IGroup } from '@customTypes/group';
import { createCalendarEventsFromSchedule } from 'components/ScheduleCalendar/ScheduleCalendar';

import { deleteEventById, getEventsByGroup, saveEventToFirestore } from './groups';

export async function regenerateGeneratedEventsForGroup(group: IGroup) {
    const existingEvents = await getEventsByGroup(group.id);
    const generatedEvents = existingEvents.filter(e => e.generated);

    await Promise.all(generatedEvents.map(event => deleteEventById(group.id, event.id)));

    const newEvents = await createCalendarEventsFromSchedule(group);
    console.log('newEvents', newEvents);
    await Promise.all(
        newEvents.map(event =>
            saveEventToFirestore(group.id, {
                ...event,
                generated: true,
            }),
        ),
    );
}
